// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jZMJ","clinicsSelect":"styles_clinicsSelect__1dODs"};